import feedbackErrorsTemplate from 'templates/feedback-errors.pug'

import emitter from 'garden/src/js/utils/emitter'

import BaseComponent from 'scripts/components/base-component'

const DEFAULTS = {
  floatingButton: false,
  errors: {
    fail: ['Erro ao carregar o chat, tente novamente mais tarde'],
    loading: ['Chat está carregamento, aguarde um momento e tente novamente']
  }
}

class ChatbotWidget extends BaseComponent {
  static componentName = 'chatbot-widget'

  constructor ($element, options) {
    super($element)

    this.options = Object.assign({}, DEFAULTS, options)
  }

  init () {
    this.bindGlobalTriggers()
  }

  bindGlobalTriggers () {
    this.triggers = document.querySelectorAll('[data-chatbot-trigger]')

    Array.prototype.forEach.call(
      this.triggers,
      (trigger) => {
        trigger.classList.remove('hidden')
        trigger.addEventListener(
          'click',
          this.triggerOpen.bind(this),
          false
        )
      }
    )
  }

  showError (type) {
    const { errors } = this.options

    emitter.emit('stickyFeedback:error', {
      title: 'Ops! Ocorreram os seguintes erros:',
      content: feedbackErrorsTemplate({
        errors: errors[type]
      })
    })
  }

  triggerOpen () {
    if (!this.isWidgetInserted()) {
      return this.showError('loading')
    }

    window.ChatWidget.open()
  }

  isWidgetInserted () {
    return !!document.getElementById('chatWidgetFrame')
  }
}

export default ($el) => new ChatbotWidget($el, $el.data()).init()

export { ChatbotWidget as Component }
